<div class="aui-page-panel" style="padding-right: 1px">
  <div class="aui-page-panel-inner">
    <section class="aui-page-panel-content" style="padding-left: 0; padding-right: 0; padding-top: 0">
      <div class="aui-toolbar2">
        <div class="aui-toolbar2-inner">
          <div class="aui-toolbar2-primary">
            <div id="button-set2" class="aui-buttons">
              <app-button
                [iconType]="IconTypes.ArrowLeftCircle"
                [id]="'back-to-timer-btn'"
                [btnTitle]="'Back to the initial section'"
                (clickHandler)="goBack()"
              >
                Back
              </app-button>
            </div>
          </div>
          <div class="aui-toolbar2-secondary">
            <div class="aui-buttons"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<ng-container *ngIf="loaded; else loadingSpinner">
  <section>
    <form class="aui top-label">
      <div class="field-group">
        <label for="obsidian-token">Obsidian Token</label>
        <input
          class="text long-field"
          type="text"
          id="obsidian-token"
          [value]="token?.token"
          placeholder="Click 'Generate' button"
          readonly
        />
      </div>

      <div class="buttons-container">
        <app-button *ngIf="!token" [classNames]="'aui-button-primary'" (clickHandler)="generateToken($event)">
          Generate
        </app-button>
        <app-button
          *ngIf="token"
          (clickHandler)="removeToken($event)"
          [iconType]="IconTypes.Trash"
          [iconClasses]="'delete'"
        >
          Remove token
        </app-button>
        <span>&nbsp;&nbsp;</span>
        <app-button (clickHandler)="downloadConnector($event)" [iconType]="IconTypes.Download">
          Download connector
        </app-button>
      </div>
    </form>
  </section>

  <div class="p-top-10">
    <app-message [title]="'How to setup'" [type]="'info'">
      <p>1. Download provided archive. It contains a fresh Vault with preinstalled Connector plugin.</p>
      <p>2. In Obsidian, add a new Vault and point to the downloaded folder.</p>
      <p>3. Generate a new token and paste it into the plugin settings in Obsidian.</p>
      <p>4. Enjoy using Obsidian with Jira!</p>
    </app-message>
  </div>
</ng-container>

<ng-template #loadingSpinner>
  <div class="aui-group spinner-center">
    <app-spinner></app-spinner>
  </div>
</ng-template>
